import styled from 'styled-components';

export const StyledFileUploadInput = styled.input`
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 1.6rem;
`;
